import { useEffect } from 'react'
import { useBucket } from '@mc/experiments-react'
import { COLLAPSED_PAINTED_DOOR_FLAG_NAME } from '../constants'
import { trackCollapsedPaintedDoorViewed } from '../events/trackCollapsedPaintedDoorViewed'

export const useExperiment = ({ track }: { track?: boolean } = {}) => {
  const variant = useBucket(COLLAPSED_PAINTED_DOOR_FLAG_NAME)

  useEffect(() => {
    if (track) {
      trackCollapsedPaintedDoorViewed()
    }
  }, [track])

  return {
    isOn: variant === 'control' || variant?.startsWith('variant'),
    isVariant: variant?.startsWith('variant'),
    variant,
  }
}
